import moment from 'moment'
import { useMemo } from 'react'
import { TripItem } from 'tripPlanner/types/tripItem'

export function useJustAddedTripItem(item: TripItem) {
  // can remove isFromEmail in item after contract update.
  return useMemo(() => {
    return 'isFromEmail' in item && item.isFromEmail as boolean && item.createdAt.isBetween(moment().subtract(1, 'day'), moment())
  }, [item])
}
